module.exports = __webpack_public_path__ + "static/img/loginbg.0577d34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginbg.png
// module id = OBOK
// module chunks = 1